import { ActionDisabledCondition, UserAction } from '@mediahaven/shared';
import { ApiFragment, RecordStatus, RecordTypeStructure } from '@stylehaven/components';

/*  Show progress
 *  Available when:
 *   * Is processing or rejected
 *   * Is Data or DataFlat
 *
 *  Disabled when:
 *   * Never
 */
export function GetShowProcessingProgressUserAction(record: ApiFragment): UserAction {
    const includedStatusses: RecordStatus[] = [RecordStatus.Processing, RecordStatus.Rejected];
    const isIncludedStatus: boolean = includedStatusses.includes(record.getRecordStatus());

    const includedStructures: RecordTypeStructure[] = [RecordTypeStructure.Data, RecordTypeStructure.DataFlat];
    const isDataOrFlat: boolean = includedStructures.includes(record.getRecordStructure());

    const availableConditions: boolean[] = [isIncludedStatus, isDataOrFlat];
    const disableConditions: ActionDisabledCondition[] = [];

    const showProgressAction: UserAction = new UserAction(availableConditions, disableConditions);

    return showProgressAction;
}
